export const ORDER_CREATE = "/orders/create/";
export const ORDER_CREATE_NEW = "/orders/create/new/";
export const ORDER_GET = "/orders/get/";
export const ORDER_UPDATE = "/orders/update/";
export const ORDER_LIST = "/orders/list/";
export const ORDER_REPAYED = "/orders/repayed/";
export const ORDER_PAY_JOBS = "/orders/pay/jobs/";
